<template>
    <div class="page loginPage">
        <div class="container min-h-100 d-flex flex-column pt-4">
            <div class="row">
                <div class="col-12">
                    <h2 class="welcome mediaHideOnDesctop">Welcome back!</h2>
                    <div class="descktopMediaBox">
                        <h1>Log in to your Kettleman’s Account</h1>
                    </div>
                    <div class="loginType">
                        <div class="email" @click="switchType" :class="typeLog ?'active':'' ">
                            <div class="frame">
                                <svg width="50" height="51" viewBox="0 0 50 51" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M25 0.359863C11.1928 0.360419 0.000555556 11.5565 0 25.3686C0.000555556 39.1806 11.1928 50.3767 25 50.3773C29.2128 50.3773 33.1872 49.3336 36.6711 47.4902C37.0644 47.2818 37.215 46.7938 37.0067 46.4003C36.7983 46.0063 36.3106 45.8557 35.9172 46.0647C32.6583 47.7875 28.9461 48.7639 25 48.7639C18.5394 48.7634 12.6978 46.1464 8.46278 41.9116C4.22944 37.6751 1.61333 31.8314 1.61278 25.3686C1.61333 18.9058 4.22944 13.0621 8.46278 8.82559C12.6978 4.59078 18.5394 1.97376 25 1.9732C31.4606 1.97376 37.3022 4.59078 41.5372 8.82559C45.7706 13.0621 48.3867 18.9058 48.3872 25.3686C48.3872 27.1553 48.1872 28.8931 47.8089 30.5632C47.5011 31.9058 46.82 33.0885 45.8922 33.9232C44.9611 34.7579 43.7989 35.2542 42.4422 35.2565C40.985 35.2559 39.675 34.6713 38.7094 33.727V15.6135C38.7094 15.4012 38.6233 15.1928 38.4733 15.0428C38.3233 14.8927 38.1156 14.8066 37.9033 14.8066H12.0967C11.8844 14.8066 11.6767 14.8927 11.5267 15.0428C11.3767 15.1928 11.2906 15.4012 11.2906 15.6135V34.0477C11.2906 34.26 11.3767 34.4678 11.5267 34.6179C11.6767 34.768 11.8844 34.8541 12.0967 34.8541H37.5572C38.8122 36.0956 40.5378 36.8704 42.4422 36.8698C44.2061 36.872 45.7772 36.2012 46.9711 35.1225C48.1683 34.0433 49.0033 32.5666 49.3806 30.9233V30.9227L49.3811 30.9216C49.7861 29.1349 50 27.2759 50 25.3686C49.9994 11.5565 38.8072 0.360419 25 0.359863ZM37.0967 33.2402H12.9033V19.7072L24.5289 28.0745C24.8094 28.2762 25.19 28.2762 25.4711 28.0745L37.0967 19.7072V33.2402ZM37.0967 17.7192L25 26.4256L12.9033 17.7192V16.4199H37.0967V17.7192Z"
                                        fill="#653334"/>
                                </svg>
                            </div>
                            <div class="ttile">
                                Email
                            </div>
                        </div>
                        <div class="phone" @click="switchType" :class="!typeLog ?'active':'' ">
                            <div class="frame">
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="51" viewBox="0 0 30 51" fill="none">
                                    <path
                                        d="M26.1955 50.4976C27.908 50.4976 29.3014 49.0853 29.3014 47.3497V3.27958C29.3014 1.54395 27.908 0.131714 26.1955 0.131714H3.69133C1.97882 0.131714 0.585388 1.54395 0.585388 3.27958V47.3497C0.585388 49.0853 1.97882 50.4976 3.69133 50.4976H26.1955ZM3.69133 1.39086H26.1955C27.2231 1.39086 28.059 2.23808 28.059 3.27958V37.5215H1.82777V3.27958C1.82777 2.23808 2.6637 1.39086 3.69133 1.39086ZM1.82777 47.3497V38.7807H28.059V47.3497C28.059 48.3912 27.2231 49.2384 26.1955 49.2384H3.69133C2.6637 49.2384 1.82777 48.3912 1.82777 47.3497Z"
                                        fill="#653334"/>
                                </svg>
                            </div>
                            <div class="ttile">
                                Phone
                            </div>
                        </div>
                    </div>
                    <h2 class="mediaHideOnDesctop">Select how you want to login</h2>
                    <div class="loginForm">
                        <div>
                            <div class="form-group">
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Username / Email"
                                    :placeholder="typeLog ? 'Username / Email' : 'Phone Number' "
                                    v-model="form.username"
                                    @input="acceptNumber"
                                    @keyup.enter="login"
                                >
                            </div>
                            <div class="form-group position-relative">
                                
                                <!--<input
                                    :type="passwordType"
                                    class="form-control"
                                    placeholder="Password"
                                    v-model="form.password"
                                    @keyup.enter="login"
                                >-->
                                <md-field>
                                    <label>Password</label>
                                    <md-input v-model="form['password']" placeholder="Password" type="password"/>
                                </md-field>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-auto">
                <div class="col-12">
                    <div class="loginButton">
                        <a
                            class="btnlink zbg"
                            @click="login"
                        >Login</a>
                        <div class="passress">
                            <router-link class="h6" :to="{name: 'ResetPassword'}">
                                I forgot my password
                            </router-link>
                        </div>
                    </div>
                    <div class="descktopMediaBox">
                        <div class="signUpBox">
                            <div class="h5">
                                Don’t have an account?
                            </div>
                            <div>
                                <a class="smlBtn inv" @click.prevent="$router.push({name: 'Registration'})">
                                    sign up
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import axios from "axios";
    import md5 from "md5"

    export default {
        name: 'Login',
        data() {
            return {
                form: {
                    username: "",
                    password: null
                },
                passwordType: "password",
                passwordIcon: "show",
                typeLog: true,
            }
        },
        created() {
            this.$store.commit("shared/setTopBar", {title: "Login", showBackButton: true});
        },
        methods: {
            switchType(){
                this.typeLog = !this.typeLog;
                this.form.username = "";
            },
            acceptNumber() {
                if (this.typeLog) return;
                var x = this.form.username.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                this.form.username = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
            },
            login() {
                let data = {...this.form};
                if (!this.typeLog){
                    data.username = data.username.replace(/[^0-9]/g,'')
                }
                this.$store.dispatch("user/login", {
                    ...data,
                    callback: () => {
                        if(this.user.must_update_password){
                            this.$router.push({name: 'AccountInformation'});
                        }else{
                            this.$router.go(-1);
                        }
                        this.$store.dispatch("shared/getGatewayInfo");
                    }
                });
            }
        },
    }
</script>
